var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09747 14.7069C7.91 14.5194 7.80469 14.2651 7.80469 13.9999C7.80469 13.7348 7.91 13.4804 8.09747 13.2929L11.3905 9.99992L8.09747 6.70692C7.91532 6.51832 7.81452 6.26571 7.8168 6.00352C7.81908 5.74132 7.92425 5.49051 8.10966 5.3051C8.29506 5.11969 8.54588 5.01452 8.80807 5.01224C9.07027 5.00997 9.32287 5.11076 9.51147 5.29292L13.5115 9.29292C13.6989 9.48045 13.8043 9.73475 13.8043 9.99992C13.8043 10.2651 13.6989 10.5194 13.5115 10.7069L9.51147 14.7069C9.32395 14.8944 9.06964 14.9997 8.80447 14.9997C8.53931 14.9997 8.285 14.8944 8.09747 14.7069Z",
    fill: "#C4C4C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesChevronRight);
export default __webpack_public_path__ + "static/media/devices-chevron-right.b7796cc3b999217a78bea894abf8b4b3.svg";
export { ForwardRef as ReactComponent };